import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    gap: '10px',
    height: '36px',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0 20px',
    color: '#005FDB',
    border: 'none',
    backgroundColor: '#193B6733',
    borderRadius: '100px',
    width: '112px',
    cursor: 'pointer',
  },
  text: {
    margin: '0px',
    fontSize: '16px',
    fontWeight: 500,
    fontFamily: 'Inter',
  },
}));

interface AdditionalActionButtonProps {
  name: string;
  onClick: () => void;
  icon?: string;
  disabled?: boolean;
}

export const AdditionalActionButton: React.FC<AdditionalActionButtonProps> = ({
  name,
  onClick,
  icon,
  disabled = false,
}) => {
  const classes = useStyles();
  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className={classes.root}>
      {typeof icon !== 'undefined' && <img alt={name} src={icon} />}
      <p className={classes.text}>{name}</p>
    </button>
  );
};
